import type { NotifyPort } from '@/features/messages/domain/notify'
import type { MemberPort, TeamMember } from '../domain/member'

const setMemberAvatar = async (
	port: MemberPort,
	id: string,
	file: File,
	notify: NotifyPort,
): Promise<TeamMember> => {
	try {
		return await port.setAvatar(id, file)
	} catch {
		notify.error('hr.avatarUploadFailed')
		throw new Error('Failed to upload avatar.')
	}
}

export { setMemberAvatar }
